module.exports = __webpack_public_path__ + "media/images/icons/clock-3a06f8b05904e47fa92b587ae7569614.svg";